import React from 'react';

import {
    withStyles,
    Grid,
    Button,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis'
import SubscribeItem from './view/SubscribeItem';
import AppUtils from '../../control/apputlis';



class SubscribeChannel extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            Channels: [],
            select: [],
            selectedNum: 0,
        };

    }

    componentDidMount() {
        this.getAllLeague();
        AppUtils.YMPush('MAIN', 'SubscribeChannel');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getAllLeague = async () => {
        let result = await Apis.encryptionCompetition();
        console.log('getAllLeague', result);
        if (result.code == 200) {
            this.setState({ Channels: result.data })
        }
    }

    starLeague = async () => {
        let league_ids = [];
        for (let i = 0; i < this.state.Channels.length; i++) {
            if (this.state.select[i]) {
                league_ids.push(this.state.Channels[i].id + '_' + this.state.Channels[i].type_id);
            }
        }
        let result = await Apis.encryptionFocusLeague(JSON.stringify(league_ids));
        console.log('starLeague', result);
        if (result.data) {

        }
    }

    _onClick = (i) => {
        if (this.state.select[i]) {
            this.state.select[i] = false;
        } else {
            this.state.select[i] = true;
        }
        let num = 0;
        for (let i = 0; i < this.state.Channels.length; i++) {
            if (this.state.select[i]) {
                num += 1;
            }
        }
        this.setState({ select: this.state.select, selectedNum: num });
    }

    _onClickOk = () => {
        this.starLeague();
    }

    // 账号安全
    render() {
        const { classes } = this.props;
        const { Channels, select, selectedNum } = this.state;
        return (
            <MBack title='选择您关注的联赛'>
                <Grid container direction='row' alignItems='center' className={classes.root}>
                    {
                        Channels.map((item, i) => (
                            <Grid key={i} container justify='center' style={{ width: 90, paddingLeft: 12, paddingBottom: 12 }}>
                                <SubscribeItem selected={select[i] ? select[i] : false} nochan={true} data={item} onClick={() => this._onClick(i)} />
                            </Grid>
                        ))
                    }
                </Grid>
                <Grid container justify='center' alignItems='center' style={{
                    height: 55,
                    width: '100vw',
                    position: 'fixed',
                    boxShadow: '1px 1px 3px #8C8C8C',
                    bottom: 0
                }}>
                    <ButtonBase onClick={() => this._onClickOk()} className={classes.button}>{"选好了(" + selectedNum + ")"}</ButtonBase>
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(2, 0, 0, 0),
    },
    button: {
        width: '80vw',
        backgroundColor: theme.palette.primary.main,
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: 600,
        borderRadius: 17.5,
        height: 35,
    }

}))(SubscribeChannel));